export default function buildNavigateToParams (vehicleInspectionStation, search) {
    return {
        vehicleInspectionStationId: vehicleInspectionStation.id,
        vehicleInspectionStationSlug: vehicleInspectionStation.slug,
        vehicleFilter: search.vehicle_filter,
    }
}
